var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.3337C7.74996 18.3337 5.66663 17.5003 4.08329 15.917C3.74996 15.5837 3.74996 15.0837 4.08329 14.7503C4.41663 14.417 4.91663 14.417 5.24996 14.7503C6.58329 16.0003 8.24996 16.667 9.99996 16.667C13.6666 16.667 16.6666 13.667 16.6666 10.0003C16.6666 6.33366 13.6666 3.33366 9.99996 3.33366C8.24996 3.33366 6.58329 4.00033 5.24996 5.25033C4.58329 5.91699 3.16663 7.58366 3.08329 7.66699C2.74996 8.00033 2.24996 8.08366 1.91663 7.75033C1.58329 7.41699 1.49996 6.91699 1.83329 6.58366C1.91663 6.50033 3.33329 4.83366 4.08329 4.16699C5.66663 2.50033 7.74996 1.66699 9.99996 1.66699C14.5833 1.66699 18.3333 5.41699 18.3333 10.0003C18.3333 14.5837 14.5833 18.3337 9.99996 18.3337Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 7.91699H2.50033C2.00033 7.91699 1.66699 7.58366 1.66699 7.08366V3.75033C1.66699 3.25033 2.00033 2.91699 2.50033 2.91699C3.00033 2.91699 3.33366 3.25033 3.33366 3.75033V6.25033H5.83366C6.33366 6.25033 6.66699 6.58366 6.66699 7.08366C6.66699 7.58366 6.33366 7.91699 5.83366 7.91699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.566ae2e92b8e1499d2691ddfb57bba48.svg";
export { ForwardRef as ReactComponent };